/* eslint-disable space-before-function-paren */
/*
 * @Author: MWeiLiu
 * @Date: 2020-8-7 15点16分
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2020-8-7 15点16分
 */

const state = {
  parkActivitiesList: []
}

const actions = {
  set_parkActivitiesList(context, option) {
    context.commit('set_parkActivitiesList', option)
  }
}

const getters = {}

const mutations = {
  set_parkActivitiesList(state, option) {
    if (!state.parkActivitiesList || option.data.length === 0 || parseInt(option.message) === 101) {
      state.parkActivitiesList = []
    }
    state.parkActivitiesList.push(...option.data)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/circle/parkActivitiesList.js